const loginDirectives = angular.module('login-directives.module', []);

loginDirectives.directive('logIn', function(userService, config, $uibModal) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/login/login-module.html',
    scope: {
      onClose: '&',
    },
    link: function($scope) {
      $scope.user = {
        username: '',
        password: '',
      };

      $scope.loginURL = config.loginURL;

      $scope.onLogin = function() {
        userService.login($scope.user).then(function(response) {
          if (response.status === 200) {
            $scope.onClose();
          }
        });
      };

      $scope.forgotPassword = function() {
        const modalInstance = $uibModal.open({
          templateUrl: '/modules/modals/forgot-password-module.html',
          controller: 'forgotPasswordModalController',
          windowClass: 'medium-size-modal',
        });

        modalInstance.result.then(function() {}, function() {});
      };
    },
  };
});

loginDirectives.directive('pwstrength', function() {
  return {
    require: 'ngModel',
    link: function(scope, elem, attr, ngModel) {
      function checkPassword(str) {
        // at least one number, one lowercase and one uppercase letter
        // at least 8 characters
        const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
        return re.test(str);
      }

      //For DOM -> model validation
      ngModel.$parsers.unshift(function(value) {
        const valid = checkPassword(value);
        ngModel.$setValidity('pwstrength', valid);
        return valid ? value : undefined;
      });

      //For model -> DOM validation
      ngModel.$formatters.unshift(function(value) {
        ngModel.$setValidity('pwstrength', checkPassword(value));
        return value;
      });
    },
  };
});
